<template>
  <div class="w-full">
    <!-- member count and auto reply section  -->
    <section class="flex items-center justify-between mt-5">
        <div v-if="totalTweets" class="text-xl font-medium">
            <h4>Segment with <span class=" font-semibold">{{Object.keys(listActivity).length|| 0}}</span> members</h4>
        </div>
        <div class=" flex items-center">
          <div class="mr-10">
            <select
          class="select select-bordered "
          required
          v-model="sorting"
           @change="($event)=>{
            handleSearchList(currentSegemnt);
            }"
        >
          <option disabled="disabled" value="">Sort</option>
          <option
            value=-1
          >
            Oldest first
          </option>
          <option
            value=1
          >
            Newest first
          </option>
        </select>
          </div>
         <label class="cursor-pointer label flex items-center">
          <span class="label-text mr-5 text-lg font-medium text-gray-700">auto-like when replying</span>
          <input type="checkbox" class="toggle toggle-accent" v-model="autoLike" @click="($event)=>handleChangeAutoLike($event)"/>
         </label>
        </div>
    </section>
    <!-- tweet rendering section  -->
    <template>
      <div
        v-for="({ tweets, timestamp }, index) in listActivity"
        :key="index"
        class="w-full mt-5 bg-white p-5 shadow-sm rounded-md"
      >
        <TweetRender
          :activityInfo="tweets"
          :timestamp="timestamp"
          :autoLike="autoLike"
        />
      </div>
    </template>
  </div>
</template>

<script>
import utils from '@/services/utils';
import TweetRender from './TweetRender.vue';
import courseAPI from '@/services/course';

export default {
  name: 'Replies',
  layout: 'admin',
  data() {
    return {
      autoLike: false,
      listActivity: [],
      totalTweets: 0,
      sorting: 1,
    };
  },
  computed: {
    currentSegemnt: {
      get() {
        return this.$store.state.connect.currentSegment;
      },
      set(newValue) {
        return newValue;
      },
    },
    user() {
      return this.$store.state.user;
    },
    userDetails() {
      return this.$store.state?.userDetails;
    },
  },
  components: { TweetRender },
  watch: {
    currentSegemnt() {
      this.handleSearchList(this.currentSegemnt);
    },
  },
  async created() {
    if (!this.userInfo) {
      await this.$store.dispatch('getMyDetails', {});
    }
    this.autoLike = this.userDetails?.configureInfo?.autoLike || false;
    console.log({ userDetails: this.userDetails });
  },
  mounted() {
    if (this.$route.query.courseId) {
      this.handleSearchList(this.$route.query.courseId);
      this.$store.commit('SET_CURRENT_SEGMENT', this.$route.query.courseId);
    } else if (this.currentSegemnt) {
      this.handleSearchList(this.currentSegemnt);
    }
  },
  // created() {
  //   console.log(document.getElementById('tweetRender'));
  //   const myElement = document.getElementById('tweetRender');
  // },
  methods: {
    async handleSearchList(e) {
      try {
        this.$store.commit('toggleLoading', true);
        this.currentCourse = e;
        // const findCourse = this.courses.find((item) => item?.twitter_list_id === e.target.value);
        const data = await courseAPI.getLists(e, this.sorting);
        this.listActivity = Object.values(data?.responseData?.data);
        this.listActivity.sort((p1, p2) => {
          if (new Date(p1.count).getTime() === new Date(p2.count).getTime()) {
            return new Date(p1.timestamp) < new Date(p2.timestamp) ? this.sorting : -this.sorting;
          }
          return new Date(p1.count).getTime() > new Date(p2.count).getTime() ? 1 : -1;
        });
        this.totalTweets = data?.responseData?.totalTweets;
        this.$store.commit('toggleLoading', false);
        if (!data?.responseData?.totalTweets) {
          utils.setStatusMsg(this, 'No latest post from users');
        }
      } catch (error) {
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(
          this,
          error?.response?.data?.message ||
            error?.message ||
            'someting went wrong',
        );
        console.log({ error });
      }
    },
    async handleChangeAutoLike(e) {
      this.$store.dispatch('changeAutoLike', { autoLike: e.target?.checked });
    },
  },
};
</script>
